import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Responsive from 'react-responsive'
import Link from 'gatsby-link'
import Burger from 'react-icons/lib/fa/bars'
import AppIcon from '../images/appIcon240.png'
import LyricordText from '../images/lyricordText.png'

const Mobile = ({ children }) => <Responsive maxWidth={766} children={children} />
const Desktop = ({ children }) => <Responsive minWidth={767} children={children} />

const Separator = () => (
    <div style={{
        color: `#1e73be`,
        display: `inline-block`,
        paddingRight: `20px`,
        paddingLeft: `20px`
    }}>/</div>
)

const DecoratedLink = (props) =>
    <Link to={props.to} style={{
        color: props.focus ? `#1e73be` : `#474950`,
        textDecoration: `none`,
        fontSize: `.8em`,
        fontWeight: `700`,
    }}>
        {props.children}
    </Link>

const ListLink = props =>
    <Link to={props.to} style={{
        color: props.focus ? `#1e73be` : `#474950`,
        textDecoration: `none`,
        textTransform: `uppercase`,
        fontSize: `.8em`,
        fontWeight: `700`,
    }}>
        {props.children}
    </Link>

const Menu = ({ mobile, toggleMenu, location: { pathname } }) =>
    <div style={{
        display: `flex`,
        justifyContent: mobile ? `space-between` : `space-around`,
        alignContent: `center`,
        alignItems: `center`,
        margin: 0,
        paddingLeft: mobile ? 40 : 0,
        paddingRight: mobile ? 40 : 0,
        paddingBottom: 10,
        paddingTop: 10
    }}>
        <div style={{ minWidth: 240 }}>
        <Link to="/" style={{ textShadow: `none`, backgroundImage: `none`, margin: 0, padding: 0 }}>
            <img src={AppIcon} alt="Logo" style={{ marginBottom: 2, marginTop: 6, maxHeight: 80, marginRight: 15, marginTop: 10 }} />
            <img src={LyricordText} alt="Logo" style={{ marginBottom: 15, marginTop: 6, maxHeight: 80 }} />
        </Link>
        </div>
        <Desktop>
            <div style={{ display: `flex`, justifyContent: `space-around`, alignContent: `center`, alignItems: `center` }}>
                    <ListLink to="/" focus={(pathname == '/') ? true : false}>Home</ListLink><Separator />
                    <ListLink to="/about/" focus={(pathname.substring(0, 6) === '/about') ? true : false}>About</ListLink><Separator />
                    <ListLink to="/songwriting/" focus={(pathname == '/songwriting/') ? true : false}>Songwriting</ListLink><Separator />
                    <ListLink to="/contest/" focus={(pathname == '/contest/') ? true : false}>Contest</ListLink><Separator />
                    <ListLink to="/press-kit/" focus={(pathname == '/press-kit/') ? true : false}>Press Kit</ListLink><Separator />
                    <ListLink to="/contact/" focus={(pathname == '/contact/') ? true : false}>Contact Us</ListLink>
            </div>
        </Desktop>
        <Mobile>
            <Burger style={{ color: `#474950` }} onClick={() => toggleMenu()} />
        </Mobile>
    </div>

class Index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuOpen: false
        }
    }

    componentWillReceiveProps (nextProps) {
        this.setState({ menuOpen: false })
    }

    toggleMenu() {
        this.setState({ menuOpen: !this.state.menuOpen })
    }

    render () {
        const { children, location: { pathname }} = this.props
        return (
            <div>
                {children()}
            </div>
        )
        // return (
        //     <div style={{ paddingTop: `75px`, margin: 0 }}>
        //         <div style={{  
        //             position: `fixed`,
        //             top: `0`,
        //             width: `100%`,
        //             backgroundColor: `#EFEFEF`,
        //             zIndex: 99999,
        //             margin: 0,
        //             minWidth: 340
        //         }}>
        //             <Desktop>
        //                 <Menu mobile={false} {...this.props} />
        //             </Desktop>
        //             <Mobile>
        //                 <Menu mobile {...this.props} toggleMenu={() => this.toggleMenu()} />
        //             </Mobile>
        //             {this.state.menuOpen &&
        //                 <div style={{
        //                     width: `100%`,
        //                     backgroundColor: `#EFEFEF`,
        //                     zIndex: 99999,
        //                     display: `flex`,
        //                     flexDirection: `column`,
        //                     justifyContent: `space-around`,
        //                     alignContent: `center`,
        //                     alignItems: `center`,
        //                 }}>
        //                     <ListLink to="/" focus={(pathname == '/') ? true : false}>Home</ListLink><br />
        //                     <ListLink to="/about/" focus={(pathname.substring(0, 6) === '/about') ? true : false}>About</ListLink><br />
        //                     <ListLink to="/songwriting/" focus={(pathname == '/songwriting/') ? true : false}>SongWriting</ListLink><br />
        //                     <ListLink to="/contest/" focus={(pathname == '/contest/') ? true : false}>Contest</ListLink><br />
        //                     <ListLink to="/press-kit/" focus={(pathname == '/press-kit/') ? true : false}>Press Kit</ListLink><br />
        //                     <ListLink to="/contact/" focus={(pathname == '/contact/') ? true : false}>Contact Us</ListLink>
        //                 </div>
        //             }
        //         </div>
        //         <div style={{
        //             width: `100%`,
        //             padding: `0 10%`,
        //             marginBottom: `140px`,
        //         }}>
        //             {children()}
        //         </div>
        //     </div>
        // )
    }
}

export default Index



// WEBPACK FOOTER //
// ./src/layouts/index.js